<template>
    <structure>
        <section class="load" v-if="loadCurriculum"></section>
        <section class="curriculum" v-if="!loadCurriculum">
            <div class="title">
                <h1>Meu Currículo</h1>
                <p>Matenha os seus dados sempre atualizados</p>
            </div>
            <section class="infos-box">
                <form v-on:submit.prevent="update" >
                    <section class="form-row">
                        <div>
                            <h2>1 - Informações Pessoais</h2>
                            <div class="input-box">
                                <input id="input-name" type="text" placeholder=" " v-model="form.first_name">
                                <label for="input-name">
                                    <span>Nome</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-name" type="text" placeholder=" " v-model="form.last_name">
                                <label for="input-name">
                                    <span>Sobrenome</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-birthday" type="date" placeholder=" " v-model="form.birthday">
                                <label for="input-birthday">
                                    <span>Data de Nascimento</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-cpf" type="text" placeholder=" " v-model="form.cpf" v-mask="'###.###.###-##'">
                                <label for="input-cpf">
                                    <span>CPF</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-rg" type="text" placeholder=" " v-model="form.rg">
                                <label for="input-rg">
                                    <span>RG</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-sexo" v-model="form.sexo">
                                    <option value="">Selecione</option>
                                    <option value="Masculino">Masculino</option>
                                    <option value="Fenimino">Fenimino</option>
                                </select>
                                <label for="input-sexo">
                                    <span>Sexo</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-estado-civil" v-model="form.marital_status">
                                    <option value="">Selecione</option>
                                    <option value="Solteiro">Solteiro</option>
                                    <option value="Casado">Casado</option>
                                    <option value="Divorciado">Divorciado</option>
                                    <option value="Viúvo">Viúvo</option>
                                    <option value="Separado">Separado</option>
                                </select>
                                <label for="input-estado-civil">
                                    <span>Estado Civil</span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <h2>2 - Atuação Profissional:</h2>
                            <div class="input-box input-select">
                                <select id="input-schooling" v-model="form.occupation">
                                    <option value="Administrativo">Administrativo</option>
                                    <option value="Compras">Compras</option>
                                    <option value="Comercial">Comercial</option>
                                    <option value="Comunicação e Marketing">Comunicação e Marketing</option>
                                    <option value="Contabilidade">Contabilidade</option>
                                    <option value="Enfermagem do Trabalho">Enfermagem do Trabalho</option>
                                    <option value="Farmacêutico">Farmacêutico</option>
                                    <option value="Faturamento / Financeiro">Faturamento / Financeiro</option>
                                    <option value="Jurídico">Jurídico</option>
                                    <option value="Logística">Logística</option>
                                    <option value="Manutenção Predial">Manutenção Predial</option>
                                    <option value="Manutenção Veicular">Manutenção Veicular</option>
                                    <option value="Qualidade">Qualidade</option>
                                    <option value="Recursos Humanos">Recursos Humanos</option>
                                    <option value="Segurança">Segurança</option>
                                    <option value="Segurança do Trabalho">Segurança do Trabalho</option>
                                    <option value="Serviços Gerais / Limpeza">Serviços Gerais / Limpeza</option>
                                    <option value="Serviços Gerais / Operacional">Serviços Gerais / Operacional</option>
                                    <option value="Tecnologia da Informação">Tecnologia da Informação</option>
                                    <option value="Outro">Outro</option>
                                </select>
                                <label for="input-schooling">
                                    <span>Área de Atuação</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-funcao" type="text" placeholder=" " v-model="form.jobtitle">
                                <label for="input-funcao">
                                    <span>Função / Cargo</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-pretencao-salarial" type="text" placeholder=" " v-model="form.desired_salary" v-money="form.desired_salary">
                                <label for="input-pretencao-salarial">
                                    <span>Pretenção Salarial</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-habilidades" type="text" placeholder=" " v-model="form.skills">
                                <label for="input-habilidades">
                                    <span>Habilidades Pessoais</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-availability" v-model="form.availability">
                                    <option value="Imediata">Imediata</option>
                                    <option value="Preciso cumprir aviso">Preciso cumprir aviso</option>
                                </select>
                                <label for="input-availability">
                                    <span>Disponibilidade</span>
                                </label>
                            </div>
                            <div class="textarea-box">
                                <textarea id="input-objetivos" type="text" placeholder=" " v-textarea-resize v-model="form.goals" ></textarea>
                                <label for="input-objetivos">
                                    <span>Objetivos</span>
                                </label>
                            </div>
                        </div>
                        
                    </section>
                    <section class="form-row">
                        <div>
                            <h2>3 - Formação Acadêmica:</h2>
                            <div class="input-box input-select">
                                <select id="input-escolaridade" v-model="form.schooling">
                                    <option value="" selected>Selecione</option>
                                    <option value="Ensino Fundamental">Ensino Fundamental</option>
                                    <option value="Ensino Médio">Ensino Médio</option>
                                    <option value="Ensino Superior">Ensino Superior</option>
                                    <option value="Pós Graduação">Pós Graduação</option>
                                    <option value="Mestrado">Mestrado</option>
                                    <option value="Doutorado">Doutorado</option>
                                </select>
                                <label for="input-escolaridade">
                                    <span>Escolaridade</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-area-instituicao" type="text" placeholder=" " v-model="form.educational_institution">
                                <label for="input-area-instituicao">
                                    <span>Instituição de Ensino</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-area-curso" type="text" placeholder=" " v-model="form.course">
                                <label for="input-area-curso">
                                    <span>Curso</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-area-curso-year" type="date" placeholder=" " v-model="form.course_end_date">
                                <label for="input-area-curso-year">
                                    <span>Ano de Conclusão</span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <h2>4 - Extras</h2>
                            <div class="input-box input-select">
                                <select id="input-fumante" v-model="form.smoker">
                                    <option value="">Selecione</option>
                                    <option value="Sim">Sim</option>
                                    <option value="Não">Não</option>
                                </select>
                                <label for="input-fumante">
                                    <span>Fumante</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-necessidades" v-model="form.special_needs">
                                    <option value="Nenhuma">Nenhuma</option>
                                    <option value="Física">Física</option>
                                    <option value="Motora">Motora</option>
                                    <option value="Intelectual">Intelectual</option>
                                </select>
                                <label for="input-necessidades">
                                    <span>Necessidades Especiais</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-cnh" v-model="form.cnh">
                                    <option value="Não possuo CNH" selected>Não possuo CNH</option>
                                    <option value="Categoria A">Categoria A</option>
                                    <option value="Categoria B">Categoria B</option>
                                    <option value="Categoria A/B">Categoria A/B</option>
                                    <option value="Categoria C">Categoria C</option>
                                    <option value="Categoria D">Categoria D</option>
                                    <option value="Categoria E">Categoria E</option>
                                </select>
                                <label for="input-cnh">
                                    <span>CNH</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-cnh" v-model="form.own_car">
                                    <option value="Não" selected>Não</option>
                                    <option value="Sim" selected>Sim</option>
                                </select>
                                <label for="input-own_car">
                                    <span>Possui carro próprio?</span>
                                </label>
                            </div>
                        </div>
                    </section>
                    <section class="form-row">
                        <div>
                            <h2>5 - Idiomas:</h2>
                            <div class="input-box input-select">
                                <select id="input-portugues" v-model="form.portugues">
                                    <option value="Elementar" selected>Elementar</option>
                                    <option value="Intermediário" selected>Intermediário</option>
                                    <option value="Avançado" selected>Avançado</option>
                                    <option value="Fluente" selected>Fluente</option>
                                </select>
                                <label for="input-portugues">
                                    <span>Portugues</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-ingles" v-model="form.ingles">
                                    <option value="Elementar" selected>Elementar</option>
                                    <option value="Intermediário" selected>Intermediário</option>
                                    <option value="Avançado" selected>Avançado</option>
                                    <option value="Fluente" selected>Fluente</option>
                                </select>
                                <label for="input-ingles">
                                    <span>Inglês</span>
                                </label>
                            </div>
                            <div class="input-box input-select">
                                <select id="input-espanhol" v-model="form.espanhol">
                                    <option value="Elementar" selected>Elementar</option>
                                    <option value="Intermediário" selected>Intermediário</option>
                                    <option value="Avançado" selected>Avançado</option>
                                    <option value="Fluente" selected>Fluente</option>
                                </select>
                                <label for="input-espanhol">
                                    <span>Espanhol</span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <h2>6 - Telefones</h2>
                            <div class="input-box">
                                <input id="input-area-phone" type="text" placeholder=" " v-model="form.phone">
                                <label for="input-area-phone">
                                    <span>Telefone</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-mobile" type="text" placeholder=" " v-model="form.mobile">
                                <label for="input-mobile">
                                    <span>Celular</span>
                                </label>
                            </div>
                        </div>
                    </section>
                    <section class="form-row">
                        <div>
                            <h2>7 - Endereço</h2>
                            <div class="input-box">
                                <input id="input-cep" type="text" placeholder=" " v-model="form.cep" @blur="getAddress()"  @focus="cepError = false" v-mask="'#####-###'"> 
                                <label for="input-cep">
                                    <span>CEP <span class="error" v-if="cepError"> - O CEP informado é inválido</span></span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-estado" type="text" placeholder=" " v-model="form.uf" readonly>
                                <label for="input-estado">
                                    <span>Estado</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-cidade" type="text" placeholder=" " v-model="form.city" readonly>
                                <label for="input-cidade">
                                    <span>Cidade</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-bairro" type="text" placeholder=" " v-model="form.neighborhood" readonly>
                                <label for="input-bairro">
                                    <span>Bairro</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-endereco" type="text" placeholder=" " v-model="form.address" readonly>
                                <label for="input-endereco">
                                    <span>Endereço</span>
                                </label>
                            </div>
                            <div class="input-box">
                                <input id="input-complemento" type="text" placeholder=" " v-model="form.address_complement">
                                <label for="input-complemento">
                                    <span>Complemento</span>
                                </label>
                            </div>
                        </div>
                        <div>
                            <h2>8 - Outras Informações</h2>
                            <div class="textarea-box">
                                <textarea id="input-courses" placeholder=" " v-textarea-resize v-model="form.courses"></textarea>
                                <label for="input-courses">
                                    <span>Cursos Complementares</span>
                                </label>
                            </div>
                        </div>
                    </section>
                    <div class="control-float">
                        <button type="submit" :class="indicatorSave">Atualizar meu Currículo</button>
                    </div>
                </form>
            </section>
            <section class="experience">
                <div class="title">
                    <h1>Experiência Profissional</h1>
                </div>
                <div class="box">
                    <section class="load" v-if="loadItemsExperience"></section>
                    <ui-no-result v-if="!total && !loadItemsExperience" text="Nenhuma experiência cadastrada" class="mb-20" />
                    <section class="list-items" v-if="!loadItemsExperience">
                        <div class="item" v-for="experience in experiences" :key="experience.id">
                            <ui-menu-action class="float">
                                <ul>
                                    <li>
                                        <button type="button" @click="addExperience('edit', experience)">Editar Experiência</button>
                                    </li>
                                    <li>
                                        <button type="button" @click="remove(experience.id)">Excluir</button>
                                    </li>
                                </ul>
                            </ui-menu-action>
                            <div class="meta">
                                <h2>{{experience.company_name}}</h2>
                            </div>
                            <div class="meta-group">
                                <div class="meta">
                                    <strong>Cargo:</strong> {{experience.jobtitle}}
                                </div>
                                <div class="meta">
                                    <strong>Salário:</strong> {{experience.salary}}
                                </div>
                            </div>
                            <div class="meta-group">
                                <div class="meta">
                                    <strong>Entrada:</strong> {{experience.input_date | moment('DD/MM/YYYY')}}
                                </div>
                                <div class="meta">
                                    <strong>Saída:</strong> {{experience.output_date | moment('DD/MM/YYYY')}}
                                </div>
                            </div>
                            <div class="meta-group">
                                <div class="meta">
                                    <strong>UF:</strong> {{experience.state}}
                                </div>
                                <div class="meta">
                                     <strong>Cidade:</strong> {{experience.city}}
                                </div>
                            </div>
                            <div class="meta">
                                <strong>Atividades:</strong> 
                                <p>{{experience.activies}}</p>
                            </div>
                        </div>
                    </section>
                    <div class="control" v-if="!loadItemsExperience">
                        <button type="button" @click="addExperience()">
                            <i class="fal fa-plus"></i>
                        </button>
                    </div>
                </div>
            </section>
        </section>
        <ui-modal id="modal-experience" title="Cadastrar Experiência" title-text="Tem certeza que deseja excluir esse tipo de usuário?" size="md">
            <form v-on:submit.prevent="save">
                <div class="msg" v-if="message">{{message}}</div>
                <div class="input-box">
                    <input id="input-empresa" type="text" placeholder=" " v-model="formAdd.company_name" @focus="message = ''">
                    <label for="input-empresa">
                        <span>Nome da Empresa</span>
                    </label>
                </div>
                <div class="input-box">
                    <input id="input-cargo" type="text" placeholder=" " v-model="formAdd.jobtitle" @focus="messages = ''">
                    <label for="input-cargo">
                        <span>Cargo</span>
                    </label>
                </div>
                <div class="input-box">
                    <input id="input-admissao" type="date" placeholder=" " v-model="formAdd.input_date" @focus="message = ''">
                    <label for="input-admissao">
                        <span>Data de Admissão {{formAdd.input_date}}</span>
                    </label>
                </div>
                <div class="input-box">
                    <input id="input-data-saida" type="date" placeholder=" " v-model="formAdd.output_date" @focus="message = ''">
                    <label for="input-data-saida">
                        <span>Data de Saída</span>
                    </label>
                </div>
                <div class="input-box">
                    <input id="input-salario" type="text" placeholder=" " v-model="formAdd.salary" v-money="formAdd.salary" @focus="message = ''">
                    <label for="input-salario">
                        <span>Salário</span>
                    </label>
                </div>
                <div class="input-box input-select">
                    <select id="input-escolaridade" v-model="formAdd.state" @change="brasilCitys()">
                        <option value="">Selecione</option>
                        <option :value="estado.sigla" v-for="estado in estados" :key="estado.id">{{estado.nome}}</option>
                    </select>
                    <label for="input-escolaridade">
                        <span>Estado</span>
                    </label>
                </div>
                <div class="input-box input-select">
                    <select id="input-escolaridade" v-model="formAdd.city">
                        <option value="">Selecione</option>
                        <option :value="cidade.nome" v-for="cidade in cidades" :key="cidade.id">{{cidade.nome}}</option>
                    </select>
                    <label for="input-escolaridade">
                        <span>Cidade</span>
                    </label>
                </div>
                <div class="textarea-box">
                    <textarea id="input-text" placeholder="Ex. Gestão e capacitação de equipe de vendas" v-textarea-resize v-model="formAdd.activies" @focus="message = ''"></textarea>
                    <label for="input-text">
                        <span>Descreva suas atividades</span>
                    </label>
                </div>
                <section class="switch-box">
                    <ui-switch label="É meu emprego atual" id="retroative-date" v-model="formAdd.actual_job"  />
                </section>
                <div class="control">
                    <button type="submit" :class="experienceIndicator">Salvar</button>
                </div>
            </form>
        </ui-modal>
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import { textareaResize } from '@/directives'
    import {uiSwitch} from "@/components/index.js";
    import { uiModal, uiNoResult, uiMenuAction } from '@/components'
    import { helpers, profile, experience } from '@/services'

   

    export default {
        name: 'login',
        components: { structure, uiModal, uiSwitch, uiNoResult, uiMenuAction },
        directives: { textareaResize },
        data() {
            return {
                cepError: false,
                loadCurriculum: false,
                loadSave: false,
                loadExperience: false,
                loadItemsExperience: false,
                total: 0,
                experiences: [],
                estados: [],
                cidades: [],
                message: '',
                action: 'add',
                form: {},
                formAdd: {
                    company_name: '',
                    jobtitle: '',
                    input_date: '',
                    output_date: '',
                    salary: '',
                    activies: '',
                    state: '',
                    city: '',
                    actual_job: false,
                }
            }
        },
        computed: {
            indicatorSave(){
                return this.loadSave ? 'load' : ''
            },
            experienceIndicator(){
                return this.loadExperience ? 'load' : ''
            }
        },
        methods: {
            addExperience(action = 'add', experience = ''){
                this.msg = ''
                this.$root.$emit("modal", 'modal-experience');
                this.action = action
                if(experience){
                    this.formAdd = experience
                    this.formAdd.input_date = this.$moment(this.formAdd.input_date).format('YYYY-MM-DD')
                    this.formAdd.output_date = this.$moment(this.formAdd.output_date).format('YYYY-MM-DD')
                    this.loadCity()
                }
            },
            getAddress(){
                if(this.form.cep.length < 9){
                    this.clearAddress()
                    return false
                }
                helpers.cep(this.form.cep).then( response => {
                    if(response.data.erro){
                        this.clearAddress()
                    }else{
                        this.cepError = false
                    }
                    this.form.address       = response.data.logradouro
                    this.form.neighborhood  = response.data.bairro
                    this.form.city          = response.data.localidade
                    this.form.uf            = response.data.uf
                })
            },
            clearAddress(){
                this.cepError = true
                this.form.address = ''
                this.form.neighborhood = ''
                this.form.city = ''
                this.form.uf = ''
            },
            update(){
                this.loadSave = true
                profile.update(this.form).then( () => {
                    this.loadSave = false
                })
            },
            me(){
                this.loadCurriculum = true
                profile.me().then( response => {
                    this.form = response.data
                    this.loadCurriculum = false
                })
            },

            listExperience(){
                this.loadItemsExperience = true
                experience.list().then( response => {
                    this.experiences = response.data.rows
                    this.total = response.data.total
                    this.loadItemsExperience = false
                })
            },

            save(){
                this.loadExperience = true
                if(this.action === 'add'){
                    experience.add(this.formAdd).then( () => {
                        this.listExperience()
                        this.$root.$emit("modal-close", 'modal-experience');
                        this.loadExperience = false
                    }, error => {
                        this.message = error.response.data.message
                        this.loadExperience = false
                    })
                }

                if(this.action === 'edit'){
                    experience.update(this.formAdd).then( () => {
                        this.listExperience()
                        this.$root.$emit("modal-close", 'modal-experience');
                        this.loadExperience = false
                    }, error => {
                        this.message = error.response.data.message
                        this.loadExperience = false
                    })
                }

            },

            remove(id){
                experience.remove(id).then( () => {
                    this.listExperience()
                    this.$root.$emit("modal-close", 'modal-experience');
                })
            },

            brasilStates(){
                helpers.estados().then( response => {
                    this.estados = response.data
                })
            },
            brasilCitys(){
                this.formAdd.city = ''
                helpers.cidades(this.formAdd.state).then( response => {
                    this.cidades = response.data
                })
            },
            loadCity(){
                helpers.cidades(this.formAdd.state).then( response => {
                    this.cidades = response.data
                })
            }

        },
        created(){
            this.me()
            this.listExperience()
            this.brasilStates()
        },
        
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
